import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractRestService, GenericLambdaReturn } from '@gea-mes/cognito';

@Injectable({
  providedIn: 'root'
})
export class ObjectListService extends AbstractRestService {

  postInit(): void {
    
  }

  objectList(site?: string, environment?: string):Observable<GenericLambdaReturn<ObjectNode[]>>  {
    let params:any={};

    site ? params.Site = site.toString():null;
    environment ? params.Environment = environment.toString():null;

    return this.get({
      ApiResource: "/objectlist",
      data: params,
      repeatCall: false
    });
  }

  objectListSubscription(site?: string, environment?: string):Observable<GenericLambdaReturn<ObjectNode[]>>  {
    let params:any={};
    console.log('object-list service ', site, environment)
    site ? params.Site = site.toString():null;
    environment ? params.Environment = environment.toString():null;

    return this.get({
      ApiResource: "/objectlist",
      data: params,
      repeatCall: true
    });    
  }

  findObject(nodes:any[], objectid:string): any {
    if (!nodes) {
      return null;
    }

    for (const node of nodes) {
      // Check if the current node has the matching objectid
      if (node.objectid === objectid) {
        return node;
      }

      // If the node has children, recursively search them
      if (node.children) {
        const foundNode = this.findObject(node.children, objectid);
        if (foundNode) {
          return foundNode;
        }
      }
    }

    return null;
  }
}

export interface ObjectNode {
  description: string;
  objectid?: string;
  plantid?: boolean;  
  site?: string;
  environment?: string;
  SiteDescription?: string;
  Section?: string;
  SubSection?: string;
  updatestatus?: string;
  EAMAsset?: string;
  children?: ObjectNode[];
  loadtime: number;
  RequireComment: number;
  RequireWorkRequest: number;
  DefaultEAMAsset: number;
}
